// OAuth iniciado desde la app mobile (Robin). Mercado Pago y Google sólo tienen registrada
// la URL de retorno de Flash, así que la app pide a Cyclone una URL con su propio `state`
// (`robin-<token>`). Cuando el proveedor vuelve acá con ese state, esta página no es la que
// termina el canje: reenvía `code`/`state` (o `error`) a Cyclone ANTES de que arranquen
// Auth0 y la analítica, y Cyclone cierra el navegador de la app con `robin://…`.
// Un state que no empieza con `robin-` (el de Flash) sigue el camino de siempre.
// Mercado Pago por profesional (beta): el profesional conecta su cuenta desde un enlace, sin
// sesión; su `state` es `pro-<token>` y lo canjea `/wallet/mercado-pago/professional-return`.
const API_URL = import.meta.env?.VITE_CYCLONE_API_URL || '';

const FORWARDS: Record<string, string> = {
  '/mercado-pago/callback': '/wallet/mercado-pago/return',
  '/google-calendar/callback': '/google/calendar/oauth/return',
  // Reseñas · la ficha de Google: el `code` de un solo uso lo canjea Cyclone, no esta página.
  '/google-business/callback': '/google/business/oauth/return'
};

export const isMobileOAuthState = (state: string | null): boolean =>
  !!state && /^robin-[a-f0-9]{48}$/.test(state);

const isProfessionalMercadoPagoState = (pathname: string, state: string | null): boolean =>
  pathname === '/mercado-pago/callback' && !!state && /^pro-[a-f0-9]{48}$/.test(state);

export const mobileOAuthForwardUrl = (pathname: string, search: string, apiUrl = API_URL): string | null => {
  const params = new URLSearchParams(search);
  const state = params.get('state');
  const target = isProfessionalMercadoPagoState(pathname, state)
    ? '/wallet/mercado-pago/professional-return'
    : isMobileOAuthState(state)
      ? FORWARDS[pathname]
      : undefined;
  if (!target || !apiUrl) return null;
  const forward = new URLSearchParams();
  for (const key of ['code', 'state', 'error']) {
    const value = params.get(key);
    if (value) forward.set(key, value);
  }
  return `${apiUrl}${target}?${forward.toString()}`;
};

export const mobileOAuthForward =
  typeof window !== 'undefined'
    ? mobileOAuthForwardUrl(window.location.pathname, window.location.search)
    : null;

if (mobileOAuthForward) window.location.replace(mobileOAuthForward);
